import * as React from 'react';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import { AnchorListItem } from './AnchorListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { Location } from 'history';
import { NavLinkListItem } from './NavLinkListItem';
import { SectionContainer } from '../../containers/Nav/Section';
import { useTranslation } from 'react-i18next';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';

const { AionBackOfficeUI } = AppName;
const { Manage } = ActivityAction;
const { Roles } = ActivityResourceName;

// Take in location so that when it changes, the component re-renders and the
// active link styling is refreshed.

type Props = {
  location: Location;
  hasGlobalPermission: (action: ActivityAction, resourceName: ActivityResourceName) => boolean;
};

export const BackofficeSection: React.FC<Props> = ({ hasGlobalPermission }) => {
  const { t } = useTranslation();
  return (
    <SectionContainer
      id={AionBackOfficeUI}
      subheader={t('components.backOfficeSection.backOffice', 'Back Office')}
      icon={<MeetingRoomIcon />}
    >
      {process.env.REACT_APP_NAME === AionBackOfficeUI ? (
        <React.Fragment>
          <NavLinkListItem inset to="/organizations">
            {t('components.backOfficeSection.organizations', 'Organizations')}
          </NavLinkListItem>
          <NavLinkListItem inset to="/users">
            {t('components.backOfficeSection.users', 'Users')}
          </NavLinkListItem>
          {hasGlobalPermission(Manage, Roles) && (
            <NavLinkListItem inset to="/roles">
              {t('components.backOfficeSection.roles', 'Roles')}
            </NavLinkListItem>
          )}
          <NavLinkListItem inset to="/organizationFeatures">
            {t('components.backOfficeSection.organizationFeatures', 'Organization Features')}
          </NavLinkListItem>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <AnchorListItem inset href="/backoffice/organizations">
            {t('components.backOfficeSection.organizations', 'Organizations')}
          </AnchorListItem>
          <AnchorListItem inset href="/backoffice/users">
            {t('components.backOfficeSection.users', 'Users')}
          </AnchorListItem>
          {hasGlobalPermission(Manage, Roles) && (
            <AnchorListItem inset href="/backoffice/roles">
              {t('components.backOfficeSection.roles', 'Roles')}
            </AnchorListItem>
          )}
          <AnchorListItem inset href="/backoffice/organizationFeatures">
            {t('components.backOfficeSection.organizationFeatures', 'Organization Features')}
          </AnchorListItem>
        </React.Fragment>
      )}
    </SectionContainer>
  );
};
